import { Button, ButtonGroup, Stack, TextField } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import StudentTile from "../../../../features/core/StudentTile";
import { HomeworkDone } from "../../../../redux/homework/homeworkCheckSlice";
import { useState } from "react";
import { findHomeworkCommentRequest, homeworkCommentChange, HomeworkCommentChangeRequest, selectHomeworkCommentChange } from "../../../../redux/homework/homeworkCommentChangeSlice";
import { HomeworkInfo } from "../../../../redux/homework/homeworkSlice";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { LoadState } from "../../../../redux/common";

interface ContentProps {
    homework: HomeworkInfo;
    studentId: string;
    comment?: { comment?: string };
}

const HomeworkReviewCommentCell = (props: ContentProps) => {
    const { studentId } = props;
    const homeworkChanges = useAppSelector(selectHomeworkCommentChange);
    const dispatch = useAppDispatch();

    const [requestData, setRequestData] = useState({
        schoolId: props.homework.schoolId,
        classroomId: props.homework.classroomId,
        homeworkId: props.homework.id,
        studentId: studentId,
        comment: props.comment?.comment || ""
    } as HomeworkCommentChangeRequest);

    const request = findHomeworkCommentRequest(homeworkChanges.requests, requestData);
    const state = request?.state.state || LoadState.NotStarted;

    const isCommentEnabled = () => {
        if (state == LoadState.Loading) {
            return false;
        }
        return (props.comment?.comment || "") !== (requestData.comment || "");
    };

    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <ButtonGroup variant="contained">
                <Button 
                    color={isCommentEnabled() ? "success" : undefined}
                    onClick={() => {
                        setRequestData({ ...requestData });
                        dispatch( homeworkCommentChange(requestData) );
                    }}
                    variant="contained" disabled={!isCommentEnabled()}>
                    <SaveIcon />
                </Button>
                <Button 
                    color={isCommentEnabled() ? "error" : undefined}
                    onClick={() => setRequestData({ ...requestData, comment: props.comment?.comment || "" })}
                    variant="contained" disabled={!isCommentEnabled()}>
                    <CancelIcon />
                </Button>
            </ButtonGroup>
            <TextField
                key={`input-comment-${studentId}`}
                size="small"
                id={`outlined-basic-${studentId}`}
                label="Comentário"
                variant="outlined"
                fullWidth
                value={requestData.comment}
                onChange={(e) => setRequestData({ ...requestData, comment: e.target.value })}
                multiline
                minRows={1}
                maxRows={4}
                disabled={state == LoadState.Loading}
            />
        </Stack>
    );
};

export default HomeworkReviewCommentCell;
